export enum MeetingStatus {
New,
Cancelled,
Completed,
}
